// search element with reference to the data to query
let objSlide = document.getElementsByClassName("true-stories-preview-carousel-api");
let arrId = [];

//Get key attribute
for(let i = 0; i < objSlide.length; i++) {
    for(let l = 0; l < objSlide[i].attributes.length; l++) {
        if(objSlide[i].attributes[l].name == "key" && objSlide[i].attributes[l].name.length > 0) {
            let arrExplode = objSlide[i].attributes[l].value.split("|");
            arrId.push({
                idSlide: arrExplode[1],
                idapi: arrExplode[0],
                "type-slide": arrExplode[2],
            });
        }
    }
}

if(arrId.length > 0) {

    //Separate id by type
    let strIdsTrueStories = "",
        strIdsDietaryGoal = "";
    for(let i = 0; i < arrId.length; i++) {
        if(arrId[i]["type-slide"] == "true_stories") strIdsTrueStories += strIdsTrueStories == "" ? arrId[i]["idapi"] : "," + arrId[i]["idapi"];

        if(arrId[i]["type-slide"] == "dietary_goal") strIdsDietaryGoal += strIdsDietaryGoal == "" ? arrId[i]["idapi"] : "," + arrId[i]["idapi"];
    }

    if(strIdsTrueStories != "" && strSettingsBaseUrlTrueStories != "") {
        let requestOptions = {
            method: "GET",
        };

        // Query to endpoint for True Stories
        let strUrlEndPoint = `${strSettingsBaseUrlTrueStories}${strIdsTrueStories}`;
        fetch(strUrlEndPoint, requestOptions)
            .then((response) => response.text())
            .then((result) => {
                let arrResponse = JSON.parse(result);

                if(arrResponse["data"] && arrResponse["data"].length > 0) {
                    for(let i = 0; i < arrResponse["data"].length; i++) {
                        let idSlideKey = "";
                        for(let l = 0; l < arrId.length; l++) {
                            if(arrResponse["data"][i]["ID"] == arrId[l]["idapi"] && arrId[l]["type-slide"] == "true_stories") {
                                idSlideKey = arrId[l]["idSlide"];
                                break;
                            }
                        }

                        document.getElementById("SlideName-" + idSlideKey).innerHTML = arrResponse["data"][i]["petName"];
                        document.getElementById("SlideContent-" + idSlideKey).innerHTML = arrResponse["data"][i]["content"].slice(0, 200) + ( arrResponse["data"][i]["content"].length >= 200 ? "..." : "" );

                        for(let j = 0; j < arrResponse["data"][i]["images"].length; j++) {
                            if(arrResponse["data"][i]["images"][j]["displayImage"]) {
                                document.getElementById("SlideIMG-" + idSlideKey).src = arrResponse["data"][i]["images"][j]["imageUrl"];
                                document.getElementById("SlideIMG-" + idSlideKey).alt = arrResponse["data"][i]["images"][j]["imageDescription"];
                                break;
                            }
                        }
                    }
                }
            })
            .catch((error) => console.log("error", error));
    }

    if (strIdsDietaryGoal != "" && strSettingsBaseUrlDietaryGoal != "") {
        let requestOptions = {
            method: "GET"
        };

        //Query to endpoint for Diatary Goals
        let strUrlEndPoint = `${strSettingsBaseUrlDietaryGoal}${strIdsDietaryGoal}`;
        fetch(strUrlEndPoint, requestOptions)
            .then((response) => response.text())
            .then((result) => {
                let arrResponse = JSON.parse(result);

                if(arrResponse["data"] && arrResponse["data"].length > 0) {
                    for(let i = 0; i < arrResponse["data"].length; i++) {
                        let idSlideKey = "";
                        for(let l = 0; l < arrId.length; l++) {
                            if(arrResponse["data"][i]["ID"] == arrId[l]["idapi"] && arrId[l]["type-slide"] == "dietary_goal") {
                                idSlideKey = arrId[l]["idSlide"];
                                break;
                            }
                        }

                        document.getElementById("SlideName-" + idSlideKey).innerHTML = ""; //arrResponse["data"][i]["name"];
                        document.getElementById("SlideContent-" + idSlideKey).innerHTML = arrResponse["data"][i]["name"]; //arrResponse["data"][i]["content"];

                        let objSlideLink = document.getElementById("SlideLink-" + idSlideKey);
                        let strInnerHTMLLink = objSlideLink.innerHTML;
                        objSlideLink.innerHTML = strInnerHTMLLink.replace("*total*", arrResponse["data"][i]["count"]);
                    }
                }
            })
            .catch((error) => console.log("error", error));
    }
}
